export const FLAG_GETTING_ENDPOINTS = 'FLAG_GETTING_ENDPOINTS';
export const GET_ENDPOINTS = 'GET_ENDPOINTS';
export const CLEAR_ENDPOINTS = 'CLEAR_ENDPOINTS';
export const FLAG_ENDPOINT_ENDPOINT = 'FLAG_ENDPOINT_ENPOINT';
export const GET_ENDPOINT = 'GET_ENDPOINT';
export const CLEAR_ENDPOINT = 'CLEAR_ENDPOINT';